module.exports = __webpack_public_path__ + "img/label.aee07762.png";